import { useEffect, useState } from 'react';
import { Alert, AlertTitle, Button, CircularProgress, Stack, Typography } from '@mui/material';
import HourglassTopRounded from '@mui/icons-material/HourglassTopRounded';
import { useAuth } from '@/auth';
import { AuthLayout } from '@/layouts/AuthLayout';
import { AuthHeader } from '@/pages/auth/AuthHeader';
import { useSession } from './session';
import { ROLE_LABEL } from './types';

/**
 * Shown instead of the app while a requested role (a teacher who confirmed @cps.sp.gov.br)
 * waits for the coordination. Moves on by itself once someone approves it.
 */
export function PendingApprovalPage() {
  const { signOut } = useAuth();
  const { user, refresh } = useSession();
  const [checking, setChecking] = useState(false);
  const role = user.requestedRole ? ROLE_LABEL[user.requestedRole].toLowerCase() : 'professor(a)';

  useEffect(() => {
    const onFocus = () => void refresh();
    window.addEventListener('focus', onFocus);
    const poll = setInterval(() => void refresh(), 30_000);
    return () => {
      window.removeEventListener('focus', onFocus);
      clearInterval(poll);
    };
  }, [refresh]);

  const checkNow = async () => {
    setChecking(true);
    await refresh();
    setChecking(false);
  };

  return (
    <AuthLayout>
      <AuthHeader
        title="Aguardando aprovação"
        subtitle={`Seu e-mail ${user.institutionalEmail ?? ''} foi confirmado.`}
      />
      <Alert severity="info" icon={<HourglassTopRounded />} sx={{ mb: 3 }}>
        <AlertTitle>Falta a coordenação aprovar seu acesso como {role}</AlertTitle>
        Você recebe um e-mail assim que isso acontecer. Se esta tela estiver aberta, ela continua
        sozinha.
      </Alert>
      <Stack spacing={1.5}>
        <Button
          variant="contained"
          size="large"
          onClick={() => void checkNow()}
          disabled={checking}
        >
          {checking ? <CircularProgress size={22} color="inherit" /> : 'Verificar agora'}
        </Button>
        <Button color="inherit" onClick={() => void signOut()}>
          Sair
        </Button>
      </Stack>
      <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', mt: 3 }}>
        Demorando? Fale com a coordenação do seu curso.
      </Typography>
    </AuthLayout>
  );
}
